export default "/app/aa228670fded2df8431544ef1650e7ae.png";